import {
	Component,
	DestroyRef,
	EventEmitter,
	Input,
	OnChanges,
	OnInit,
	Output,
	SimpleChanges,
	forwardRef,
	inject,
} from '@angular/core';
import { ControlValueAccessor, FormBuilder, FormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';
import { CustomModalWithCountrySelectionComponent } from './custom-modal-with-country-selection/custom-modal-with-country-selection.component';
import { ModalController } from '@ionic/angular';
import { countries } from 'src/app/components/input-phone-with-county-code/mock-countries';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
	selector: 'app-input-phone-with-county-code',
	templateUrl: './input-phone-with-county-code.component.html',
	styleUrls: ['./input-phone-with-county-code.component.scss'],
	standalone: false,
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => InputPhoneWithCountyCodeComponent),
			multi: true,
		},
	],
})
export class InputPhoneWithCountyCodeComponent implements ControlValueAccessor, OnInit {
	flag = 'no';
	@Input() hasBackground: boolean = true;
	@Output() blurEvent = new EventEmitter();
	@Input() customStyle = false;
	onChange: any = () => {};
	onTouched: any = () => {};
	form: FormGroup;

	private destroyRef = inject(DestroyRef);
	private fb = inject(FormBuilder);
	private modalCtrl = inject(ModalController);

	constructor() {
		this.form = this.fb.group({
			phone: '',
			country: '',
		});
	}

	ngOnInit() {
		this.form.valueChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
			this.onChange({
				phone: this.form.get('phone')?.value ?? '',
				country: this.form.get('country')?.value ?? '',
			});
		});
	}
	writeValue(value: { country: string; phone: string }): void {
		console.log(value);

		console.log(value.country);
		if (value.country) {
			this.flag = countries.find(it => it.dialCode === value.country.replace('+', ''))?.flagClass;
		} else {
			this.form.patchValue(
				{
					country: '+47',
				},
				{ emitEvent: true }
			);
		}

		this.form.patchValue({
			phone: value?.phone ?? '',
			country: value?.country ?? '+47',
		});
	}

	registerOnChange(fn: any): void {
		this.onChange = fn;
	}

	registerOnTouched(fn: any): void {
		this.onTouched = fn;
	}

	async selectCountryCode() {
		const result = await CustomModalWithCountrySelectionComponent.show(this.modalCtrl, this.form.get('country')?.value);
		if (result?.dialCode) {
			this.flag = result.flagClass;
			this.form.patchValue(
				{
					country: '+' + result.dialCode,
				},
				{ emitEvent: true }
			);
		}
	}

	onPhoneBlur() {
		this.blurEvent.emit();
	}
}
